import { CASTING_BODY, CONTACT_EMAIL } from "../lib/content";
import { FadeUp } from "./Reveal";
import { CornerWebs } from "./CornerWebs";
import { FlameInitial } from "./FlameInitial";
import { EmailSignup } from "./EmailSignup";

export const CastingJoinSection = ({ source = "home" }) => (
  <section id="join" data-testid="join-section" className="relative overflow-hidden border-y border-ember/25 bg-ink pt-10 pb-14 md:pt-12 md:pb-16">
    <CornerWebs />
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame opacity-20 blur-[130px]" />
    <div className="relative z-10 mx-auto max-w-3xl px-6 text-center">
      <FadeUp>
        <p className="font-gothic text-xs uppercase tracking-[0.35em] text-flame">Casting · Partnerships · Press</p>
        <h2 className="mt-4 font-display text-4xl font-light leading-tight tracking-tight text-white md:text-5xl">
          <FlameInitial letter="H" size="0.94em" className="mr-[0.06em] translate-y-[2px] scale-x-[1.06]" />ave a journey written in skin?
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-body text-base leading-relaxed text-white/60">{CASTING_BODY}</p>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="home-casting-email"
          className="mt-5 inline-block border-b border-flame/40 pb-1 font-body text-lg tracking-wide text-flame transition-colors hover:border-ember hover:text-ember"
        >
          {CONTACT_EMAIL}
        </a>
      </FadeUp>

      <div className="mt-8 md:mt-10">
        <FadeUp>
          <p className="font-gothic text-xs uppercase tracking-[0.35em] text-flame">Join the Journey</p>
          <h2 className="mt-2 font-display text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
            <FlameInitial letter="B" size="1.06em" className="mr-[0.2em] translate-y-[5px] scale-x-[1.12]" />e first to know when the{" "}
            <span
              style={{
                backgroundImage: "linear-gradient(90deg, #FFD700 0%, #FF7A1A 50%, #E2341E 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Kickstarter launches.
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-body text-base leading-relaxed text-white/60">
            Join the Tattooed Abroad list and get notified when the campaign goes live, when episodes
            release, and when there are major updates.
          </p>
        </FadeUp>
        <FadeUp delay={0.15} className="mx-auto mt-6 max-w-xl">
          <EmailSignup source={source} />
        </FadeUp>
      </div>
    </div>
  </section>
);
